(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('checkout-after-add')) {
    class CheckoutAfterAdd extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        clearTimeout(this.revealTimer);
        clearTimeout(this.animationResetTimer);

        const productForm = this.closest('product-form-component');
        const wrapper = this.closest('.add-to-cart-with-checkout');
        const addToCartButton = wrapper?.querySelector('button[name="add"]');
        const checkoutButton = this.querySelector('.checkout-after-add__button');

        if (!productForm || !addToCartButton || !checkoutButton) return;

        this.controller = new AbortController();
        const { signal } = this.controller;

        let addStartedAt = 0;

        const resumeAttentionAnimation = () => {
          clearTimeout(this.animationResetTimer);
          wrapper.classList.remove('is-adding');
        };

        const hideCheckout = () => {
          clearTimeout(this.revealTimer);
          this.hidden = true;
          checkoutButton.disabled = false;
          wrapper.classList.remove('is-ready-for-checkout');
        };

        const revealCheckoutAfterTick = () => {
          const tickDuration = 900;
          const elapsed = addStartedAt ? performance.now() - addStartedAt : 0;
          const remaining = Math.max(0, tickDuration - elapsed);

          clearTimeout(this.revealTimer);
          this.revealTimer = setTimeout(() => {
            if (signal.aborted || !this.isConnected) return;

            this.hidden = false;
            clearTimeout(this.animationResetTimer);
            wrapper.classList.remove('is-adding');
            wrapper.classList.add('is-ready-for-checkout');
          }, remaining);
        };

        addToCartButton.addEventListener(
          'click',
          () => {
            addStartedAt = performance.now();
            hideCheckout();
            wrapper.classList.add('is-adding');

            /* Resume the animation if no Shopify result event arrives. */
            clearTimeout(this.animationResetTimer);
            this.animationResetTimer = setTimeout(() => {
              if (signal.aborted || !this.isConnected || !this.hidden) return;
              wrapper.classList.remove('is-adding');
            }, 8000);
          },
          { signal }
        );

        checkoutButton.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (this.hidden) return;

            const checkoutUrl = this.dataset.checkoutUrl;
            if (!checkoutUrl) return;

            checkoutButton.disabled = true;
            window.location.assign(checkoutUrl);
          },
          { signal }
        );

        // Horizon versions using the original cart event.
        productForm.addEventListener(
          'cart:update',
          (event) => {
            if (event.target !== productForm) return;

            const data = event.detail?.data;

            if (data?.source !== 'product-form-component') return;

            if (data.didError || event.detail?.resource?.status) {
              resumeAttentionAnimation();
              return;
            }

            revealCheckoutAfterTick();
          },
          { signal }
        );

        // Newer versions: wait for the confirmed result, not the initial event.
        productForm.addEventListener(
          'shopify:cart:lines-update',
          async (event) => {
            if (
              event.target !== productForm ||
              event.action !== 'add' ||
              !event.promise
            ) {
              return;
            }

            try {
              const result = await event.promise;

              if (
                signal.aborted ||
                !this.isConnected
              ) {
                return;
              }

              if (
                result?.detail?.didError ||
                result?.userErrors?.length ||
                !(result?.cart?.totalQuantity > 0)
              ) {
                resumeAttentionAnimation();
                return;
              }

              revealCheckoutAfterTick();
            } catch {
              // The theme already displays errors from a failed add.
              resumeAttentionAnimation();
            }
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.revealTimer);
        clearTimeout(this.animationResetTimer);
      }
    }

    customElements.define('checkout-after-add', CheckoutAfterAdd);
  }
  } catch(e) { console.error(e); }
})();

})();
